import { Component, effect, inject, ChangeDetectionStrategy } from '@angular/core';
import { Link } from "../directives/link";
import { Seo } from '../services/seo';
import { QRCode } from '@synapxlab/qrcode';
import { Biggen } from "../directives/biggen";
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Component({
  selector: 'app-footer',
  imports: [Link, Biggen],
  templateUrl: './footer.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './footer.scss',
})
export class Footer {
  private seo = inject(Seo);
  private dom = inject(DomSanitizer);
  address: string = '';
  qrCode!: SafeResourceUrl;
  canCopy: boolean = false;

  copyLink = async () => {
    try {
      if (this.address && this.canCopy) {
        const clip = await navigator.clipboard.writeText(this.address);
      }
    } catch {
      console.log("Error copying to clipboard.");
    }
  }

  constructor() {
    effect(async () => {
      this.address = this.seo.address();
      const data = QRCode.toSVG(this.address, { errorCorrection: 'L' });
      this.qrCode = this.dom.bypassSecurityTrustResourceUrl(`data:image/svg+xml;base64,${btoa(data)}`);
    });

    try {
      this.canCopy = navigator.canShare({ url: this.address });
    } catch {
      this.canCopy = false;
    }
  }
}
